import { GridOptions } from 'ag-grid-community';
import React, { ComponentType, FC } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';

type KnownProps = Pick<
  GridOptions,
  | 'overlayLoadingTemplate'
  | 'rowBuffer'
  | 'immutableData'
  | 'valueCache'
  | 'animateRows'
  | 'enableCellChangeFlash'
  | 'suppressMaxRenderedRowRestriction'
  | 'suppressMaintainUnsortedOrder'
  | 'suppressFocusAfterRefresh'
  | 'suppressContextMenu'
  | 'defaultColDef'
  | 'cellFlashDelay'
  | 'suppressDragLeaveHidesColumns'
>;

export const withDefaultProps = <T extends KnownProps>(
  Component: ComponentType<T>,
): FC<Omit<T, keyof KnownProps>> => {
  const next: FC<Omit<T, keyof KnownProps>> = (props) => {
    return (
      <Component
        {...(props as any)}
        overlayLoadingTemplate="<div></div>"
        immutableData
        valueCache
        animateRows
        enableCellChangeFlash
        suppressMaxRenderedRowRestriction
        suppressFocusAfterRefresh
        suppressMaintainUnsortedOrder
        suppressContextMenu
        suppressDragLeaveHidesColumns
        debounceVerticalScrollbar
        disableStaticMarkup
        defaultColDef={{
          sortable: true,
          resizable: true,
          editable: true,
          suppressMenu: true,
          suppressMovable: true,
        }}
        cellFlashDelay={3000}
      />
    );
  };

  return setDisplayName(wrapDisplayName(Component, 'WithDefaultProps'))(next);
};
